import React from 'react';
import { Grid } from 'semantic-ui-react';
import Form from '../components/Form';
var Inline = function Inline(props) {
  return /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Column, {
    computer: "1",
    tablet: "1",
    only: "computer tablet"
  }), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: "14",
    tablet: "14",
    mobile: "16"
  }, /*#__PURE__*/React.createElement(Form, props)), /*#__PURE__*/React.createElement(Grid.Column, {
    computer: "1",
    tablet: "1",
    only: "computer tablet"
  }));
};
export default Inline;